import { find, includes, isEmpty, keys, some } from 'lodash/fp';

import { FIELD_NAMES, WHEN_FIELD_NAMES, WHO_FIELD_NAMES } from '../../../../constants';

const FIRST_MODAL_FIELDS = [FIELD_NAMES.WHERE];
const SECOND_MODAL_FIELDS = [FIELD_NAMES.WHEN, ...WHEN_FIELD_NAMES];
const THIRD_MODAL_FIELDS = [FIELD_NAMES.WHO, ...WHO_FIELD_NAMES];

type GetPanelIndexForErrorParams = {
  errors: Record<string, string>;
};

const MODAL_FIELDS = [
  { fields: FIRST_MODAL_FIELDS, index: 0 },
  { fields: SECOND_MODAL_FIELDS, index: 1 },
  { fields: THIRD_MODAL_FIELDS, index: 2 },
];

const getPanelIndexForError = ({ errors }: GetPanelIndexForErrorParams) => {
  const errorFields = keys(errors);
  if (isEmpty(errorFields)) {
    return null;
  }

  const matchingPanel = find(({ fields }) => some((field) => includes(field, fields), errorFields), MODAL_FIELDS);
  if (!matchingPanel) {
    return null;
  }

  return matchingPanel ? matchingPanel.index : null;
};

export default getPanelIndexForError;
